jQuery(document).ready(async function($) {
    'use strict';

    const d3 = window.d3;

    if (!d3) {
        return;
    }

    const priceFormat = '%2$s %1$s';

    const productIdElement = document.querySelector('.product_id');

    if (!productIdElement) {
        return;
    }

    const productId = productIdElement.value;

    if (!productId) {
        return;
    }

    let variationId = null;

    let priceHistory = null;

    $('form.cart .single_variation').on('show_variation', onVariationChanged);

    priceHistory = await getPriceHistory(productId);

    renderPriceHistoryGraph();

    function onVariationChanged(e, variation) {
        variationId = variation.variation_id;
        renderPriceHistoryGraph();
    }

    function renderPriceHistoryGraph() {
        if (priceHistory == null) {
            return;
        }

        const data = variationId
            ? priceHistory.history[variationId]
            : priceHistory.history;

        if (!data) {
            return;
        }

        // Max value observed:
        const prices = {
            min: d3.min(data, function(d) { return d.price; }),
            max: d3.max(data, function(d) { return d.price; }),
            mean: d3.mean(data, function(d) { return d.price; }),
        };

        // Find the <span> element with the class 'min-price', insert min price
        let spanElement = document.querySelector('.min-price');

        if (spanElement) {
            spanElement.textContent =
                formatPrice(priceFormat, prices.min, 'kr', 0);
        }

        const margin = {top: 20, right: 60, bottom: 75, left: 55},
            width = 480 - margin.left - margin.right,
            height = 300 - margin.top - margin.bottom;

        $('#chart-container').empty();

        const svg = d3.select('#chart-container')
            .append('svg')
            .attr('viewBox', `0 0 480 300`)
            .attr('class', 'price-history-graph font-body')
            .append('g')
            .attr(
                'transform',
                `translate(${margin.left}, ${margin.top})`,
            );

        const x = d3.scaleTime()
            .domain(d3.extent(data, function(d) { return d.date; }))
            .range([0, width]);

        const y = d3.scaleLinear()
            .domain([
                d3.min(data, function(d) { return d.price; }) * 0.98,
                d3.max(data, function(d) { return d.price; }) * 1.02,
            ])
            .nice()
            .range([height, 0]);

        const lines = {
            price: d3.line()
                .x(function(d) { return x(d.date); })
                .y(function(d) { return y(d.price); })
                .curve(d3.curveStep),
            min: d3.line()
                .x(function(d) { return x(d.date); })
                .y(function() { return y(prices.min); }),
            max: d3.line()
                .x(function(d) { return x(d.date); })
                .y(function() { return y(prices.max); }),
            mean: d3.line()
                .x(function(d) { return x(d.date); })
                .y(function() { return y(prices.mean); }),
        };

        const bisect = d3.bisector(function(d) { return d.date; }).left;

        svg.append('path')
            .datum(data)
            .attr('class', 'line')
            .attr('d', lines.price)
            .style('fill', 'none')
            .style('stroke', '#00944d')
            .style('stroke-width', '2px');
        svg.append('path')
            .datum(data)
            .attr('class', 'min')
            .attr('stroke-dasharray', '4')
            .attr('d', lines.min)
            .style('fill', 'none')
            .style('stroke', 'grey')
            .style('stroke-width', '1px');
        svg.append('path')
            .datum(data)
            .attr('class', 'max')
            .attr('stroke-dasharray', '4')
            .attr('d', lines.max)
            .style('fill', 'none')
            .style('stroke', 'grey')
            .style('stroke-width', '1px');
        svg.append('path')
            .datum(data)
            .attr('class', 'mean')
            .attr('stroke-dasharray', '4')
            .attr('d', lines.mean)
            .style('fill', 'none')
            .style('stroke', 'grey')
            .style('stroke-width', '1px');

        svg.append('g')
            .attr('class', 'x-axis')
            .attr('transform', 'translate(0,' + height + ')')
            .call(d3.axisBottom(x).tickFormat(d => {
                const dateFormat = new Intl.DateTimeFormat(
                    'sv-SE',
                    {day: 'numeric', month: 'numeric'},
                );
                return dateFormat.format(d);
            }))
            .selectAll('text')
            .style('text-anchor', 'end')
            .attr('transform', 'rotate(-45)')
            .attr('font-family', 'Open Sans, sans-serif');

        svg.append('g')
            .attr('class', 'y-axis')
            .style('width', '70px')
            .call(d3.axisLeft(y)
                .tickFormat(d => formatPrice(
                    priceFormat,
                    d,
                    'kr',
                    0,
                )))
            .selectAll('text')
            .attr('width', '100px')
            .attr('font-family', 'Open Sans, sans-serif');

        svg.append('text')
            .attr('class', 'mean-label')
            .attr('style', 'font-size: 12px')
            .attr('font-family', 'Open Sans, sans-serif')
            .attr(
                'transform',
                `translate(-${margin.left}, ${height + margin.top + 27})`,
            )
            .text(`Medelpris: ${formatPrice(
                priceFormat,
                prices.mean,
                'kr',
                0,
            )}`);

        const focus = svg
            .append('g')
            .append('circle')
            .style('fill', '#00944d')
            .style('opacity', 0)
            .attr('stroke', '#00944d')
            .attr('r', 4);
        const focusLabel = svg
            .append('g')
            .style('opacity', 0);
        focusLabel
            .append('rect')
            .style('fill', '#f5f5f5');
        focusLabel
            .append('text')
            .style('transform', 'translate(3px, 0)')
            .style('alignment-baseline', 'before-edge');

        svg
            .append('rect')
            .style('fill', 'none')
            .style('pointer-events', 'all')
            .attr('width', width)
            .attr('height', height)
            .on('mouseover', onMouseOver)
            .on('mousemove', onMouseMove)
            .on('mouseout', onMouseOut);

        function onMouseOver() {
            focus.style('opacity', 1);
            focusLabel.style('opacity', 1);
        }

        function onMouseMove() {
            const x0 = x.invert(d3.mouse(this)[0]);
            const i = bisect(data, x0, 1);

            const selectedData = data[i];
            if (!selectedData) {
                return;
            }

            focus
                .attr('cx', x(selectedData.date))
                .attr('cy', y(selectedData.price));

            focusLabel.select('text')
                .html(formatPrice(priceFormat, selectedData.price, 'kr', 0));

            const rect = focusLabel
                .select('text')
                .node()
                .getBoundingClientRect();

            const xPos = x(selectedData.date) - rect.width / 2;
            const yPos = y(selectedData.price) - rect.height - 16;

            focusLabel
                .select('rect')
                .attr('width', rect.width + 6)
                .attr('height', rect.height);
            focusLabel
                .attr('transform', `translate(${xPos}, ${yPos})`);
        }

        function onMouseOut() {
            focus.style('opacity', 0);
            focusLabel.style('opacity', 0);
        }
    }

    async function getPriceHistory(productId) {
        const response = await fetch(`/wp-json/kilamobler/v1/price-history/${productId}`);
        const result = await response.json();
        switch (result.type) {
            case 'variable':
                const keys = Object.keys(result.history);
                for (let i = 0, l = keys.length; i < l; ++i) {
                    result.history[keys[i]] =
                        result.history[keys[i]].map(d => ({
                            date: new Date(d.date),
                            price: d.price,
                        }));
                }

                break;
            default:
                result.history = result.history.map(d => ({
                    date: new Date(d.date),
                    price: d.price,
                }));

                break;
        }

        return result;
    }

    function formatPrice(format, price, symbol, decimals) {
        if (!price) {
            return format
                .replace('%1$s', 0)
                .replace('%2$s', symbol);
        }

        price =
            price.toFixed(decimals)
                .toString()
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
                .replace('.', ',');
        return format
            .replace('%1$s', symbol)
            .replace('%2$s', price);
    }
});
